import axios from 'axios';

const API = axios.create({ baseURL: process.env.REACT_APP_Server_link })

API.interceptors.request.use((req) => {
    if (localStorage.getItem('profile')) { 
      req.headers.Authorization = `${JSON.parse(localStorage.getItem('profile')).token}`
    }
    return req; 
  });  

export const fetchPost = (id) => API.get(`/posts/${id}`);
export const fetchPosts = (page) => API.get(`/posts?page=${page}`); 
export const fetchUserPosts = (userId) => API.get(`/posts/myPosts/${userId}`);
export const fetchUserSavedPosts = (userId) => API.get(`/posts/saved/${userId}`);
export const fetchPostsBySearch = (searchQuery) => API.get(`/posts/search?searchQuery=${searchQuery.searchVal || 'none'}&tags=${searchQuery.tags}`);
 
export const createPost = (newPost) => API.post('/posts', newPost);
export const likePost = (id) => API.patch(`/posts/${id}/likePost`);
export const savePost = (id) => API.patch(`/posts/${id}/savePost`);
export const comment = (value, id) => API.post(`/posts/${id}/commentPost`, { value });
export const updatePost = (id, updatedPost) => API.patch(`/posts/${id}`, updatedPost)
export const deletePost = (id) => API.delete(`/posts/${id}`);


export const signIn = (formData) => API.post('/user/signin', formData);
export const signUp = (formData) => API.post('/user/signup', formData);

